<template>
    <main role="main">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="page-bn s3-1bn">
            <h3>{{ $t('HEADER.LATESTNEWS') }}</h3>
        </div> 
        
        <div v-if="isLoading" style="min-height:600px">
        </div>
        <div class="page-con-detailed"  >
            <div class="detailed-con">
            <nav>
                <p>{{ $t('CATEGORY.TITLE') }}</p>
                <ol>
                    <li :class="{ active: 'all' == activeCategory  }" @click="SwitchCategory('all')"><a class="page-link" >{{ $t('CATEGORY.ALL') }}</a></li>
                    <li :class="{ active: item.id == activeCategory }" v-for="(item) in section.list" :key="item.id" @click="SwitchCategory(item.id)"><a class="page-link" >{{item.name}}</a></li>
                </ol>
            </nav>
            <ul> 
                <div class="oops" v-if="datas.length == 0 && !isLoading">
                    <img src="../../../static/images/10/oops.png" alt="">
                </div>   
                <li v-for="(item) in ShowData" :key="item.id">
                    <a :href="item.data.is_link ? item.data.link : '/news/' + item.id" :target="item.data.is_link ? '_blank' : false">
                        <div class="detailed-img" :style="{ 'background-image': 'url('+ item.data.src+')' }" >
                        </div>
                        <div class="detailed-txt">
                            <p class="time">{{item.data.date}}  ｜  {{item.data.category_name}}</p>
                            <h4>{{item.data.title}}</h4>
                            <i></i>
                        </div>
                    </a>
                </li>
            </ul>
            <Pagination :dataLength="datas.length" @start="getStart" @end="getEnd"></Pagination>
            </div>
        </div>
        <IndexFooter></IndexFooter>
    </main>
</template>
<script>
import {fb, db } from '../../firebase'
export default {
    name: 'News',
    data () {
        return {
            tmp:[],
            datas:[],
            section:{},
            activeCategory:'all',
            isLoading: false,
            fullPage: true,
            start:0,
            end:0
        }
    },
    computed: {
        ShowData: function () {
            return this.datas.slice(this.start-1, this.end-1);
        }
    },
    mounted () {
        this.GetCategory();
    },
    methods: {
        FindName(selected) {
            if (this.section.list.find(x=>x.id == selected))
                return this.section.list.find(x=>x.id == selected).name;
            else 
                return ''
        },
        GetCategory() {
            this.isLoading = true;
            db.collection(this.$t('DB.CATEGORY')).doc('news').get().then((doc) => {
                if (doc.exists) {
                    this.section = doc.data();
                    this.section.list.sort( (d1, d2) => d2.order - d1.order);
                    this.Get();
                } 
            }).catch((error) => {
                console.log("Error getting document:", error);
                this.isLoading = false;
            });
            
        },
        Get(){
            var vm = this;
            // 取得列表
            db.collection(this.$t('DB.NEWS')).where('selected', '==', 'news').get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    var item = doc.data();
                    item.category_name =  this.FindName(doc.data().list_selected);
                    var data = {"id": doc.id, "data": item};
                
                    this.datas.push(data);
                });
                this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);

                this.tmp = this.datas;
                this.isLoading = false;
            }).catch((error) => {
                console.log("Error getting document:", error);
                this.isLoading = false;
            });
        },
        SwitchCategory(id){
            if ( id == 'all') this.datas = this.tmp;
            else    this.datas = this.tmp.filter(x => x.data.list_selected == id);
            this.activeCategory = id;
        },
        getStart(val){
            this.start = val;
        },
        getEnd(val){
            this.end = val;
        }
    }
}
</script>
<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/index/News.vue